import {
  ref,
  onMounted,
  defineComponent,
  reactive,
  computed,
  PropType,
} from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";

import { last as Rlast } from "ramda";

import {
  CWorkOrderTask,
  CWorkOrderTaskLineItem,
} from "@/store/modules/workOrderTasks";

import { JSConn } from "@/utilities/js-conn";

export default defineComponent({
  name: "buildWorkOrderTaskLineItemEditForm",

  props: {
    formLineItem: {
      type: Object as PropType<CWorkOrderTaskLineItem>,
      required: true,
    },
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const cancelEdit = (evt: any) => {
      evt.preventDefault();
      ctx.emit("editCanceled");
    };

    const firstInput = ref<any>(null);

    const onSubmit = (evt: any) => {
      evt.preventDefault();

      const jsConn = new JSConn();

      let storeDispatch;

      jsConn.formParams = {
        ...props.formLineItem,
      };

      storeDispatch = "updateWorkOrderTaskLineItem";

      $store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          ctx.emit("editSuccessful");
        })
        .catch(_jsConn => {
          // this.hasTaskErrors = true;
          // this.taskErrors = jsConn.error["response"]["data"];
        });
    };

    onMounted(() => {
      ctx.root.$nextTick(() => {
        if (firstInput.value) {
          firstInput.value.focus();
        }
      });
    });

    return {
      cancelEdit,
      onSubmit,

      firstInput,
    };
  },
});
